import script from "./BookItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BookItem.vue?vue&type=script&setup=true&lang=js"

import "./BookItem.vue?vue&type=style&index=0&id=0d07a964&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d07a964"]])

export default __exports__